/* ============================================
   KALMO — tema Shopify
   Interacciones + carrito real (Cart AJAX API)
   ============================================ */
(function () {
  "use strict";

  var routes = window.routes || {};
  var moneyFormat = (window.KALMO && window.KALMO.moneyFormat) || null;

  /* ---------- utilidades ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var value = cents / 100;
    try {
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: (window.KALMO && window.KALMO.currency) || "COP",
        maximumFractionDigits: 0
      }).format(value);
    } catch (e) {
      return "$" + Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }

  /* ---------- Header: sombra al hacer scroll ---------- */
  var header = document.getElementById("site-header");
  function onScroll() {
    if (!header) return;
    header.classList.toggle("scrolled", window.scrollY > 12);
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---------- Menú móvil ---------- */
  var navToggle = document.getElementById("nav-toggle");
  var mobileNav = document.getElementById("mobile-nav");
  var navBackdrop = document.getElementById("mobile-nav-backdrop");

  function openNav() {
    if (!mobileNav) return;
    mobileNav.classList.add("open");
    if (navBackdrop) navBackdrop.classList.add("open");
    if (navToggle) navToggle.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
  }
  function closeNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove("open");
    if (navBackdrop) navBackdrop.classList.remove("open");
    if (navToggle) navToggle.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
  }
  if (navToggle) {
    navToggle.addEventListener("click", function () {
      mobileNav.classList.contains("open") ? closeNav() : openNav();
    });
  }
  if (navBackdrop) navBackdrop.addEventListener("click", closeNav);
  if (mobileNav) $$("a", mobileNav).forEach(function (a) { a.addEventListener("click", closeNav); });

  /* ---------- Acordeón de preguntas ---------- */
  var triggers = $$(".accordion-trigger");
  triggers.forEach(function (trigger) {
    var panel = trigger.nextElementSibling;
    trigger.addEventListener("click", function () {
      var isOpen = trigger.getAttribute("aria-expanded") === "true";
      triggers.forEach(function (t) {
        t.setAttribute("aria-expanded", "false");
        if (t.nextElementSibling) t.nextElementSibling.style.maxHeight = null;
      });
      if (!isOpen) {
        trigger.setAttribute("aria-expanded", "true");
        if (panel) panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });

  /* ---------- Aparición al hacer scroll ---------- */
  function initReveal() {
    var els = $$(".reveal:not(.in-view)");
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("in-view"); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("in-view");
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0, rootMargin: "0px 0px 120px 0px" });

    els.forEach(function (el) {
      // Si ya pasó por encima de la pantalla, se muestra directamente
      if (el.getBoundingClientRect().bottom < 0) el.classList.add("in-view");
      else obs.observe(el);
    });
  }
  initReveal();

  /* ---------- Galería de producto ---------- */
  function initGallery() {
    var main = $("#gallery-main-img");
    var thumbs = $$(".gallery-thumb");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var src = thumb.getAttribute("data-full");
        if (src) {
          main.src = src;
          main.removeAttribute("srcset");
        }
        thumbs.forEach(function (t) {
          t.classList.remove("is-active");
          t.setAttribute("aria-selected", "false");
        });
        thumb.classList.add("is-active");
        thumb.setAttribute("aria-selected", "true");
      });
    });
  }
  initGallery();

  /* ============================================
     CARRITO — Shopify Cart AJAX API
     ============================================ */
  var cartDrawer = document.getElementById("cart-drawer");
  var cartBackdrop = document.getElementById("cart-backdrop");
  var cartItemsEl = document.getElementById("cart-items");
  var cartSummaryEl = document.getElementById("cart-summary");
  var cartSubtotalEl = document.getElementById("cart-subtotal");
  var cartBadge = document.getElementById("cart-badge");

  function openCart() {
    if (!cartDrawer) return;
    closeNav();
    cartDrawer.classList.add("open");
    cartDrawer.setAttribute("aria-hidden", "false");
    if (cartBackdrop) cartBackdrop.classList.add("open");
    document.body.style.overflow = "hidden";
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove("open");
    cartDrawer.setAttribute("aria-hidden", "true");
    if (cartBackdrop) cartBackdrop.classList.remove("open");
    document.body.style.overflow = "";
  }

  var cartToggle = document.getElementById("cart-toggle");
  if (cartToggle) {
    cartToggle.addEventListener("click", function (e) {
      e.preventDefault();
      fetchCart().then(openCart);
    });
  }
  var cartClose = document.getElementById("cart-close");
  if (cartClose) cartClose.addEventListener("click", closeCart);
  if (cartBackdrop) cartBackdrop.addEventListener("click", closeCart);
  var cartContinue = document.getElementById("cart-continue-btn");
  if (cartContinue) cartContinue.addEventListener("click", closeCart);

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (cartDrawer && cartDrawer.classList.contains("open")) closeCart();
    else closeNav();
  });

  var trashIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2m-9 0 1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13"/></svg>';

  function renderCart(cart) {
    if (cartBadge) {
      if (cart.item_count > 0) {
        cartBadge.hidden = false;
        cartBadge.textContent = cart.item_count > 9 ? "9+" : String(cart.item_count);
      } else {
        cartBadge.hidden = true;
      }
    }
    if (!cartItemsEl) return;

    if (!cart.items.length) {
      cartItemsEl.innerHTML =
        '<div class="cart-empty">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 6h2l1.6 9.6a2 2 0 0 0 2 1.98h7.6a2 2 0 0 0 2-1.7L20.5 9H7"/><circle cx="10" cy="20" r="1.4" fill="currentColor" stroke="none"/><circle cx="17" cy="20" r="1.4" fill="currentColor" stroke="none"/></svg>' +
        "<p>Tu carrito está vacío.</p>" +
        '<a href="' + (routes.cart_url ? "/collections/all" : "/") + '" class="btn btn-ghost">Ver productos</a>' +
        "</div>";
      if (cartSummaryEl) cartSummaryEl.hidden = true;
      return;
    }

    cartItemsEl.innerHTML = cart.items.map(function (item, i) {
      var img = item.image
        ? item.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2")
        : "";
      return (
        '<div class="cart-item" data-line="' + (i + 1) + '">' +
        (img ? '<img class="cart-item-img" src="' + img + '" alt="" width="72" height="72">' : '<div class="cart-item-img"></div>') +
        '<div class="cart-item-info">' +
        '<p class="cart-item-name">' + item.product_title + "</p>" +
        (item.variant_title && item.variant_title !== "Default Title"
          ? '<p class="cart-item-price">' + item.variant_title + "</p>" : "") +
        '<p class="cart-item-price">' + formatMoney(item.price) + " c/u</p>" +
        '<div class="qty-stepper" data-line="' + (i + 1) + '">' +
        '<button type="button" class="qty-btn" data-action="dec" aria-label="Reducir cantidad">−</button>' +
        '<span class="qty-value">' + item.quantity + "</span>" +
        '<button type="button" class="qty-btn" data-action="inc" aria-label="Aumentar cantidad">+</button>' +
        "</div></div>" +
        '<div class="cart-item-side">' +
        '<span class="cart-item-total">' + formatMoney(item.line_price) + "</span>" +
        '<button type="button" class="cart-item-remove" data-action="remove" aria-label="Eliminar producto">' + trashIcon + "</button>" +
        "</div></div>"
      );
    }).join("");

    if (cartSummaryEl) cartSummaryEl.hidden = false;
    if (cartSubtotalEl) cartSubtotalEl.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch(routes.cart_url ? routes.cart_url + ".js" : "/cart.js", {
      headers: { "Accept": "application/json" }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { /* silencio: el carrito sigue accesible en /cart */ });
  }

  function changeLine(line, quantity) {
    return fetch(routes.cart_change_url || "/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  if (cartItemsEl) {
    cartItemsEl.addEventListener("click", function (e) {
      var btn = e.target.closest("button[data-action]");
      if (!btn) return;
      var row = btn.closest("[data-line]");
      if (!row) return;
      var line = parseInt(row.getAttribute("data-line"), 10);
      var action = btn.getAttribute("data-action");

      if (action === "remove") {
        changeLine(line, 0);
      } else {
        var qtyEl = $(".qty-value", row.closest(".cart-item"));
        var current = parseInt(qtyEl ? qtyEl.textContent : "1", 10) || 1;
        changeLine(line, action === "inc" ? current + 1 : Math.max(0, current - 1));
      }
    });
  }

  /* ---------- Formularios de "Agregar al carrito" ---------- */
  $$("form[action*='/cart/add']").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = $("[type=submit]", form);
      var original = btn ? btn.textContent : "";
      if (btn) { btn.disabled = true; btn.textContent = "Agregando…"; }

      fetch(routes.cart_add_url || "/cart/add.js", {
        method: "POST",
        headers: { "Accept": "application/json" },
        body: new FormData(form)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.status !== 200) throw new Error(res.description || "Error");
          return fetchCart();
        })
        .then(function () { openCart(); })
        .catch(function () { window.location.href = routes.cart_url || "/cart"; })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = original; }
        });
    });
  });

  /* ---------- Selector de paquetes (cantidad) ---------- */
  var bundleCards = $$(".bundle-card");
  var qtyInput = $("#product-qty-input");
  var addBtn = $("#product-add-btn");

  if (bundleCards.length) {
    bundleCards.forEach(function (card) {
      card.addEventListener("click", function () {
        bundleCards.forEach(function (c) { c.classList.remove("is-selected"); });
        card.classList.add("is-selected");
        if (qtyInput) qtyInput.value = card.getAttribute("data-qty") || "1";
        if (addBtn) addBtn.disabled = false;
      });
    });
  }

  // Carga inicial del contador del carrito
  fetchCart();
})();
